import React from "react"

import { BROKER_ALERT_DESC_CLASS } from "./brokerAlertUi"
import BrokerGuidancePanel from "./BrokerGuidancePanel"
import CtraderCsvStatementColumnGuidance from "./CtraderCsvStatementColumnGuidance"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
} from "./ibkrGuidanceShared"

export interface CtraderStatementImportGuidanceProps {
  compact?: boolean
  /** When false, omit the re-import / analytics note (e.g. csv-only broker with no dual tabs). */
  showReimportNote?: boolean
  /** When false, omit Tessera account-picker copy (demo has no account chrome). */
  showAccountNotes?: boolean
}

const CtraderStatementImportGuidance = ({
  compact = false,
  showReimportNote = true,
  showAccountNotes = true,
}: CtraderStatementImportGuidanceProps): React.ReactElement => {
  return (
    <BrokerGuidancePanel title="How to export your cTrader statement CSV" compact={compact} collapsible>
      <GuidanceAccordionBody>
        <CtraderCsvStatementColumnGuidance forCsvImport />
        {showAccountNotes ? (
          <GuidanceBlock title="Account in Tessera">
            <ChecklistRow className="!mb-0">
              Choose an existing Tessera account below, or enter a new account number if this
              statement is for a different login. The account number is not included in the export
              file.
            </ChecklistRow>
          </GuidanceBlock>
        ) : null}
        {showReimportNote ? (
          <p className={`${BROKER_ALERT_DESC_CLASS} !mb-0`}>
            Re-importing for the same account adds or updates trades. Portfolio analytics use
            trading P&amp;L only.
          </p>
        ) : null}
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default CtraderStatementImportGuidance
